import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUndo = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.1 18.5H7V16.5H14.1C15.15 16.5 16.0623 16.1667 16.837 15.5C17.6123 14.8333 18 14 18 13C18 12 17.6123 11.1667 16.837 10.5C16.0623 9.83333 15.15 9.5 14.1 9.5H7.8L10.4 12.1L9 13.5L4 8.5L9 3.5L10.4 4.9L7.8 7.5H14.1C15.7167 7.5 17.1043 8.025 18.263 9.075C19.421 10.125 20 11.4333 20 13C20 14.5667 19.421 15.875 18.263 16.925C17.1043 17.975 15.7167 18.5 14.1 18.5Z",
		fill: "currentColor"
	})
});
export default SvgUndo;
